<!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
@if (!isIframe) {
  <router-outlet></router-outlet>
}
<app-loading-indicator [detectRouteTransitions]="true" />
<app-site-footer class="mt-auto"></app-site-footer>
